import { render, staticRenderFns } from "./DiscountDetails.vue?vue&type=template&id=3ec39474&scoped=true"
import script from "./DiscountDetails.vue?vue&type=script&lang=js"
export * from "./DiscountDetails.vue?vue&type=script&lang=js"
import style0 from "./DiscountDetails.vue?vue&type=style&index=0&id=3ec39474&prod&scoped=true&lang=css"
import style1 from "./DiscountDetails.vue?vue&type=style&index=1&id=3ec39474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec39474",
  null
  
)

export default component.exports